import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNotepad"><Path fillRule="evenodd" clipRule="evenodd" d="M9 1.5V2.5H11V1.5H13V2.5H15V1.5H17V2.5H20.5V21.5H3.5V2.5H7V1.5H9ZM8 9H16V11H8V9ZM8 13H14V15H8V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotepad;
